import * as WebBrowser from 'expo-web-browser'
import { useEffect, useState } from 'react'
import { StyleSheet, View } from 'react-native'
import { Button, Text } from 'react-native-paper'
import Logo from '../../assets/images/adaptee-gastro-logo.svg'
import { ColorsEnum } from '../constants/colors'
import { FontsEnum } from '../constants/fonts'
import { isWeb } from '../constants/platform'
import { useAuth } from '../hooks/useAuth'
import MainLoader from './UI/loaders/MainLoader'

if (isWeb) {
    WebBrowser.maybeCompleteAuthSession()
}

const AuthScreen = () => {
    const [isPressed, setIsPressed] = useState(false)

    const [isOAuthRefresh, result, promptAsync] = useAuth()

    useEffect(() => {
        if (!result || result.type !== 'dismiss' || !isWeb) return

        setIsPressed(false)
    }, [result])

    const handlePress = () => {
        promptAsync()

        setIsPressed(true)
    }

    if (isPressed || isOAuthRefresh || !isWeb) {
        return <MainLoader />
    }

    return (
        <View style={styles.container}>
            <Logo viewBox="0 0 775 420" />
            <Button mode="outlined" onPress={handlePress} style={styles.button}>
                <Text style={styles.buttonText}>Přihlásit se</Text>
            </Button>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        justifyContent: 'center',
        flex: 1,
        backgroundColor: '#FFFFFF',
        paddingTop: 40,
    },
    button: {
        borderColor: ColorsEnum.PRIMARY,
    },
    buttonText: {
        color: ColorsEnum.PRIMARY,
        fontFamily: FontsEnum.RUBIK_400_REGULAR,
    },
})

export default AuthScreen
